import { createSlice, PayloadAction } from "redux-starter-kit";

export interface FeedsShowMoreSlice {
    visible_product_count: number;
    total_product_count: number;
    remaining_product_count: number;
    show_more_next_url: string;
    show_more_text: string;
}

const initialState: FeedsShowMoreSlice = {
    visible_product_count: 0,
    total_product_count: 0,
    remaining_product_count: 0,
    show_more_next_url: "",
    show_more_text: "",
};

const feedsShowMore = createSlice({
    slice: "feedsShowMore",
    initialState,
    reducers: {
        setButtonNextUrl(state, action: PayloadAction<string>): void {
            state.show_more_next_url = action.payload;
        },
        setVisibleProductCount(state, action: PayloadAction<number>): void {
            state.visible_product_count = action.payload;
        },
        setRemainingProductCount(state, action: PayloadAction<number>): void {
            state.remaining_product_count = action.payload;
        },
        setTotalProductCount(state, action: PayloadAction<number>): void {
            state.total_product_count = action.payload;
        },
        setButtonText(state, action: PayloadAction<string>): void {
            state.show_more_text = action.payload;
        },
        setAll(state, action: PayloadAction<FeedsShowMoreSlice>): void {
            state.show_more_next_url = action.payload.show_more_next_url;
            state.total_product_count = action.payload.total_product_count;
            state.remaining_product_count = action.payload.remaining_product_count;
            state.visible_product_count = action.payload.visible_product_count;
            state.show_more_text = action.payload.show_more_text;
        },
    },
});

const { actions, reducer } = feedsShowMore;
export const {
    setVisibleProductCount,
    setTotalProductCount,
    setRemainingProductCount,
    setButtonNextUrl,
    setAll,
} = actions;
export default reducer;
